import { createSlice } from "@reduxjs/toolkit";
import { sessionService } from "redux-react-session";
import ReactGA from "react-ga4";
import { BASE_API_URL } from "../constants";
import { runUnauthorizedActions } from "features/account/loginSlice";
import { getMatchingItemsYears } from "features/functions";

const initialState = {
	isLoading: false,
	value: "",
	selectedItem: {},
	suggestions: [],
	renderInput: false,
	list: null,
};

const vehicleYears = createSlice({
	name: "vehicleYears",
	initialState,
	reducers: {
		requestVehicleYearsList(state) {
			state.isLoading = true;
		},
		receiveVehicleYearsList(state, action) {
			state.isLoading = false;
			state.list = action.payload.list;
			state.renderInput = action.payload.renderInput;
		},
		loadVehicleYearsSuggestionsBegin(state) {
			state.isLoading = true;
		},
		maybeUpdateVehicleYearsSuggestions(state, action) {
			state.isLoading = false;
			if (state.value !== action.payload.value) {
			} else {
				state.suggestions = action.payload.suggestions;
			}
		},
		updateVehicleYearValue(state, action) {
			state.value = action.payload.value;
		},
		updateVehicleYearItem(state, {payload}) {
			if (payload.selectedItem?.anio != null) {
				ReactGA.event({
					category: "Vehiculo",
					action: "Seleccionar Año",
					label: payload.selectedItem.anio + "",
					value: payload.selectedItem.anio,
				});
			}
			state.selectedItem = payload.selectedItem;
		},
		clearVehicleYearsSuggestions(state) {
			state.suggestions = [];
		},
		clearVehicleYearValue(state, action) {
			state.value = "";
			state.selectedItem = {};
			state.renderInput = action.payload.renderInput;
		},
		clearVehicleYearData: () => initialState,
	},
});

export const {
	requestVehicleYearsList,
	receiveVehicleYearsList,
	loadVehicleYearsSuggestionsBegin,
	maybeUpdateVehicleYearsSuggestions,
	updateVehicleYearValue,
	updateVehicleYearItem,
	clearVehicleYearsSuggestions,
	clearVehicleYearValue,
	clearVehicleYearData,
} = vehicleYears.actions;

const shouldFetchVehicleYears = (state, modelId) => {
	const model = state.vehicleModels.selectedItem;
	if (state.vehicleYears.list == null) {
		if (model != null) {
			return true;
		}
		return false;
	}
	if (model?.ID !== modelId) {
		return true;
	}
	return false;
};
export const fetchVehicleYearsIfNeeded = (modelId) => async (
	dispatch,
	getState
) => {
	const theState = getState();
	if (shouldFetchVehicleYears(theState, modelId)) {
		return dispatch(
			fetchVehicleYears(theState.vehicleBrands.selectedItem.ID, modelId)
		);
	}
};
export const loadVehicleYearsSuggestions = (value) => async (
	dispatch,
	getState
) => {
	dispatch(loadVehicleYearsSuggestionsBegin());
	const theState = getState();
	dispatch(fetchVehicleYearsIfNeeded(theState.vehicleModels.selectedItem.ID));
	setTimeout(() => {
		dispatch(
			maybeUpdateVehicleYearsSuggestions({
				suggestions: getMatchingItemsYears(theState.vehicleYears, value),
				value,
			})
		);
	});
};
export const fetchVehicleYears = (brandId, modelId) => async (dispatch) => {
	sessionService
		.loadSession()
		.then((session) => {
			const headers = {
				Authorization: "bearer " + session.loginData.access_token,
				"Content-Type": "application/json",
			};
			const options = {
				method: "GET",
				headers: headers,
			};
			dispatch(requestVehicleYearsList());
			let responseStatus = 0;
			const url =
				BASE_API_URL +
				"/api/FamilyFriends/Vehiculos/Buscar/Anios/?marca=" +
				brandId +
				"&modelo=" +
				modelId;
			return fetch(url, options)
				.then((response) => {
					responseStatus = response.status;
					if (response.ok) {
						return response.json();
					} else {
						return Promise.reject("Ocurrió un error");
					}
				})
				.then((json) => {
					dispatch(receiveVehicleYearsList({ list: json, renderInput: true }));
				})
				.catch((error) => {
					// TODO: fetch error actions
					// If 401 Unauthorized login failed
					if (responseStatus === 401) {
						dispatch(runUnauthorizedActions());
					}
				});
		})
		.catch((err) => console.log("Error", err));
};

export default vehicleYears.reducer;
